import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const NoticeIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.5 9.376H11.5C10.672 9.376 10 9.963 10 10.688C10 11.413 10.672 12.001 11.5 12.001H12.5C13.328 12.001 14 12.589 14 13.313C14 14.038 13.328 14.626 12.5 14.626H10.5M12 8.501V9.376M12 14.626V15.501M8.823 5.073L6.24 5.348C5.769 5.398 5.398 5.769 5.348 6.24L5.073 8.823C5.053 9.016 4.977 9.198 4.856 9.348L3.223 11.369C2.926 11.737 2.926 12.263 3.223 12.631L4.856 14.652C4.977 14.802 5.053 14.984 5.073 15.177L5.348 17.76C5.398 18.231 5.769 18.602 6.24 18.652L8.823 18.927C9.016 18.947 9.198 19.023 9.348 19.144L11.369 20.777C11.737 21.074 12.263 21.074 12.631 20.777L14.652 19.144C14.802 19.023 14.984 18.947 15.177 18.927L17.76 18.652C18.231 18.602 18.602 18.231 18.652 17.76L18.927 15.177C18.947 14.984 19.023 14.802 19.144 14.652L20.777 12.631C21.074 12.263 21.074 11.737 20.777 11.369L19.144 9.348C19.023 9.198 18.947 9.016 18.927 8.823L18.652 6.24C18.602 5.769 18.231 5.398 17.76 5.348L15.177 5.073C14.984 5.053 14.802 4.977 14.652 4.856L12.631 3.223C12.263 2.926 11.737 2.926 11.369 3.223L9.348 4.856C9.198 4.977 9.016 5.053 8.823 5.073Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

NoticeIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(NoticeIcon);
